/* src/app/layouts/admin-layout/components/navbar/components/modal-user-profile/modal-user-profile.component.scss */
.overlay {
  outline: 1px dashed #92b0b3;
}
/*# sourceMappingURL=modal-user-profile.component.css.map */
